import { ISelectionResult } from './ISelectionResult'

export class ToteSelectionResult implements ISelectionResult {
  constructor(selectionString: string) {
    this.selectionStrings = [selectionString]
  }

  public selectionStrings: string[]
}
